const Au_Server = 'ap-southeast-2';
const Us_Server = 'us-west-2';
const Asia_Server = 'ap-southeast-1';

const Au_Pool = 'userpools-v2';

const Au_Host = '.com.au';
const Uk_Host = '.co.uk';
const Us_host = '.com';
const Asia_Host = '.asia';

export function serverChecker(hostname) {
  let server_name = null;

  if (hostname === null || hostname.length === 0) return;

  if (typeof(hostname) === 'string') {
    if (hostname.includes(Au_Host)) {
      server_name = {
        server: Au_Server,
        pool: Au_Pool
      };
    } else if(hostname.includes(Uk_Host)) {
      server_name = {
        server: Au_Server,
        pool: Au_Pool
      };
    } else if(hostname.includes(Us_host)) {
      server_name = {
        server: Us_Server,
        pool: Au_Pool
      };
    } else if(hostname.includes(Asia_Host)) {
      server_name = {
        server: Asia_Server,
        pool: Au_Pool
      };
    } else {
      server_name = {
        server: Au_Server,
        pool: Au_Pool
      };
    }
  }

  return server_name;
}